// extracted by mini-css-extract-plugin
module.exports = {"errorMessageContainer":"Error404_errorMessageContainer__2sspn","title":"Error404_title__3gvMK","homeLink":"Error404_homeLink__1xA9j"};